import { makeStyles, createStyles } from "@mui/styles";
const useStyles = makeStyles((theme) =>
  createStyles({
    serviceseg: {
      height: "100%",
      width: "100%",
    },
    serviceslist: {
      marginTop: "64px",
      display: "flex",
      padding: "32px 64px",
      justifyContent: "space-evenly",
      [theme.breakpoints.down("md")]: {
        flexDirection: "row",
        justifyContent: "space-around",
        flexWrap:'wrap',
      },
    },
    card: {
      width: "300px",
      borderRadius: "16px",
      [theme.breakpoints.down("md")]: {
        margin: "16px 4px",
      },
    },
    cardactionarea: {
      height: "100%",
    },
    cardmedia: {
      height: "150px",
      width: "150px",
    },
    servicename: {
      textAlign: "center",
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "16px",
    },
    aboutsseg: {
      height: "100%",
      width: "100%",
    },
    aboutstext: {
      fontSize: "24px",
      marginRight: "16px",
      marginBottom: "16px",
    },
    aboutusdesc: {
      fontSize: "18px",
      lineHeight: "1.5rem",
      marginBottom: "24px",
    },
    footer: {
      height: "90px",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      display: "flex",
      flexDirection: "column",
    },
    footerdecor: {
      flex: 1,
      backgroundColor: theme.palette.secondary.main,
    },
    footercontent: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "18px",
      [theme.breakpoints.down("xs")]: {
        textAlign: "center",
      },
    },
    aboutusmobile: {
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
    bannerspace: {
      height: "48px",
      position: "relative",
      whiteSpace: "nowrap",
      display: "flex",
      alignItems: "center",
      animation: "$scrolltext 120s linear infinite",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowX: "scroll",
        animation: "none",
      },
    },
    bannercontent: {
      height: "48px",
      display: "flex",
      alignItems: "center",
      background: theme.palette.secondary.main,
    },
    "@keyframes scrolltext": {
      "0%": {
        transform: "translate(0, 0)",
      },
      "100%": {
        transform: "translate(-100%, 0)",
      },
    },
  })
);

export default useStyles;
